function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 23"
}, React.createElement("circle", {
  cx: 57,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 60,
  cy: 34,
  r: 2
}), React.createElement("circle", {
  cx: 60,
  cy: 44,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 22,
  r: 2
}), React.createElement("circle", {
  cx: 7,
  cy: 57,
  r: 2
}), React.createElement("circle", {
  cx: 4,
  cy: 34,
  r: 2
}), React.createElement("circle", {
  cx: 4,
  cy: 44,
  r: 2
}), React.createElement("path", {
  d: "M32 19c-9.93 0-18 9.42-18 21a22.68 22.68 0 006.37 16c3.7-10 10.63-28.17 10.7-28.36A1 1 0 0132 27a1 1 0 01.94.65l10.58 28.48A22.63 22.63 0 0050 40c0-11.58-8.07-21-18-21z"
}), React.createElement("path", {
  d: "M22.53 55.94C25.12 59.2 28.46 61 32 61s6.78-1.75 9.36-4.92L32 30.84c-2 5.16-6.57 17.24-9.47 25.1zM25 18v.46a17.51 17.51 0 0114 0V18a7 7 0 00-14 0z"
}), React.createElement("circle", {
  cx: 43,
  cy: 4,
  r: 2
}), React.createElement("circle", {
  cx: 21,
  cy: 4,
  r: 2
}), React.createElement("path", {
  d: "M53.71 52.29A1 1 0 0053 52h-4a21.08 21.08 0 01-1.19 2h4.74l1.71 1.71a3.11 3.11 0 011.41-1.41zM57 34a3 3 0 01.18-1h-6.13c.18.65.34 1.32.47 2h5.66a3 3 0 01-.18-1zM51.82 43c-.08.67-.18 1.34-.31 2h5.67a2.87 2.87 0 010-2zM10.29 26.71A1 1 0 0011 27h4.51a23.31 23.31 0 011.35-2h-5.45L9.7 23.29a3.11 3.11 0 01-1.41 1.41zM11 52a1 1 0 00-.71.29l-2 2a3.11 3.11 0 011.41 1.42L11.41 54h4.74c-.43-.64-.82-1.31-1.19-2zM6.82 33a2.87 2.87 0 010 2h5.66c.13-.68.29-1.35.47-2zM12.49 45c-.13-.66-.23-1.33-.31-2H6.82a2.87 2.87 0 010 2zM41.71 6.7a3.11 3.11 0 01-1.41-1.41l-4.55 4.54a9 9 0 011.76 1.07zM26.49 10.9a9 9 0 011.76-1.07L23.7 5.29a3.11 3.11 0 01-1.41 1.41z"
}), React.createElement("circle", {
  cx: 57,
  cy: 22,
  r: 2
}), React.createElement("path", {
  d: "M53 27a1 1 0 00.71-.29l2-2a3.11 3.11 0 01-1.41-1.41L52.59 25h-5.45a23.31 23.31 0 011.35 2z"
}));

var SvgBugobj = function SvgBugobj(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
};

export default SvgBugobj;